import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-prix-produit-cond-type-client-card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "text-black fw-semibold" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-12 m-10" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "border border-primary mb-10" }
const _hoisted_15 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_16 = { class: "col-md-5" }
const _hoisted_17 = { class: "d-flex float-end" }
const _hoisted_18 = { class: "p-3" }
const _hoisted_19 = { class: "col-md-5" }
const _hoisted_20 = { class: "form-group mb-2" }
const _hoisted_21 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = { class: "form-group mb-2" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { class: "col-md-2" }
const _hoisted_26 = { class: "form-group mb-2" }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_29 = {
  key: 1,
  class: "invalid-feedback"
}
const _hoisted_30 = {
  key: 2,
  class: "invalid-feedback"
}
const _hoisted_31 = { class: "col-md-2" }
const _hoisted_32 = { class: "form-group mb-2" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = { class: "col-md-1" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "col-md-12 mt-5" }
const _hoisted_37 = { class: "d-flex align-items-center" }
const _hoisted_38 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, " Définir un prix pour " + _toDisplayString(_ctx.produit?.nomProd || 'le produit'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Form, {
        ref: "prixProduitCondTypeClientForm",
        onSubmit: _ctx.addPrixProduitCondTypeClient,
        "validation-schema": _ctx.prixProduitCondTypeClientSchema,
        "keep-values": _ctx.valuess
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Date de définition "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "dateDefinition",
                  type: "date",
                  value: _ctx.getCurrentDate(),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Sélectionner la date de définition",
                  readonly: ""
                }, null, 8, ["value"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateDefinition",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Groupe de Taxe"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "groupe" }, {
                  default: _withCtx(({ setValue }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.groupeOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.groupe,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.groupe) = $event)),
                        (val) => { setValue(val); _ctx.onGroupeSelect(val); }
                      ],
                      placeholder: "Sélectionner un groupe"
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "groupe",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Mode de définition"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "mode" }, {
                  default: _withCtx(({ setValue }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.modeOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.mode,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mode) = $event)),
                        (val) => { setValue(val); }
                      ],
                      disabled: _ctx.estRedonly,
                      placeholder: "Sélectionner le mode de définition"
                    }, null, 8, ["options", "modelValue", "disabled", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "mode",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-7" }, [
                      _createElementVNode("h4", { class: "fs-4 text-white" }, "Définir les prix")
                    ], -1)),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-success",
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addRowPrix()))
                        }, _cache[6] || (_cache[6] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                          _createTextVNode(" Ajouter un prix ")
                        ]))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row mt-10" }, [
                        _createElementVNode("div", { class: "col-md-5" }, [
                          _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                            _createTextVNode(" Produit Conditionnement "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ])
                        ]),
                        _createElementVNode("div", { class: "col-md-2" }, [
                          _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Prix Min (XOF) ")
                        ]),
                        _createElementVNode("div", { class: "col-md-2" }, [
                          _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                            _createTextVNode(" Prix de Vente (XOF) "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ])
                        ]),
                        _createElementVNode("div", { class: "col-md-2" }, [
                          _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Prix Max (XOF) ")
                        ]),
                        _createElementVNode("div", { class: "col-md-1" }, [
                          _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Action")
                        ])
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prixList, (prix, prixIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "row gy-0",
                          key: prixIndex
                        }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_Multiselect, {
                                options: _ctx.produitConditionnementOptions,
                                searchable: true,
                                "track-by": "label",
                                label: "label",
                                modelValue: prix.produitConditionnement,
                                "onUpdate:modelValue": ($event: any) => ((prix.produitConditionnement) = $event),
                                placeholder: "Sélectionner le produit conditionnement",
                                onSelect: ($event: any) => (_ctx.selectProduitConditionnement(prix.produitConditionnement, prix))
                              }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"]),
                              (_ctx.validatePrixRow(prix.produitConditionnement))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Le produit conditionnement est obligatoire. "))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": ($event: any) => ((prix.prixMin) = $event),
                                step: "0.01",
                                min: "0",
                                class: "form-control shadow-none fs-md-15 text-black"
                              }, null, 8, _hoisted_24), [
                                [_vModelText, prix.prixMin]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": ($event: any) => ((prix.prix) = $event),
                                step: "0.01",
                                min: "0",
                                class: _normalizeClass(_ctx.validatePrixRow(prix.prix) || prix.prix < prix.prixMin || prix.prix > prix.prixMax
                                      ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                      : 'form-control shadow-none fs-md-15 text-black'
                                      ),
                                placeholder: "Entrez le prix en Francs CFA"
                              }, null, 10, _hoisted_27), [
                                [_vModelText, prix.prix]
                              ]),
                              (_ctx.validatePrixRow(prix.prix))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Le prix est obligatoire. "))
                                : _createCommentVNode("", true),
                              (prix.prix < prix.prixMin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Le prix doit être supérieur ou égal au prix minimum. "))
                                : _createCommentVNode("", true),
                              (prix.prix > prix.prixMax)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Le prix doit être inférieur ou égal au prix maximum. "))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": ($event: any) => ((prix.prixMax) = $event),
                                step: "0.01",
                                min: "0",
                                class: "form-control shadow-none fs-md-15 text-black"
                              }, null, 8, _hoisted_33), [
                                [_vModelText, prix.prixMax]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("button", {
                              class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeRowPrix(prixIndex))
                            }, _cache[8] || (_cache[8] = [
                              _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                            ]), 8, _hoisted_35)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-success me-3", { 'cursor-not-allowed': _ctx.isDisable }]),
                  type: "submit",
                  disabled: _ctx.isDisable
                }, " Ajouter un prix produit conditionnement ", 10, _hoisted_38),
                _createVNode(_component_router_link, {
                  to: "/prixproduits/liste-prixproduits",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, "Annuler", -1)
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "keep-values"])
    ])
  ]))
}